import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { BrandedLoadingState } from '@/components/common';
import { routes } from '@/config/routes';
import { useAuth } from '@/features/auth/context';

export function GuestOnlyRoute({ children }: { children: ReactNode }) {
  const { status, isAuthenticated } = useAuth();
  if (status === 'initializing') return <BrandedLoadingState />;
  if (isAuthenticated) return <Navigate to={routes.dashboard} replace />;
  return children;
}
